var _title, _g, _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRevert(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "50px",
    height: "48.167px",
    viewBox: "0 0 50 48.167",
    enableBackground: "new 0 0 50 48.167",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "App Home") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _title || (_title = /*#__PURE__*/React.createElement("title", null, "Artboard 76")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M42.967,6.784v35.302H22.136L9.335,24.434l12.8-17.65H42.967 M45.667,4.083H20.759L6,24.434l14.759,20.352h24.908V4.083 L45.667,4.083z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.707,24.435l6.901-6.901c0.507-0.506,0.507-1.328,0-1.833c-0.506-0.506-1.326-0.506-1.833,0l-6.9,6.902l-6.901-6.901 c-0.506-0.506-1.327-0.506-1.833,0s-0.506,1.327,0,1.833l6.901,6.901l-6.901,6.902c-0.506,0.506-0.506,1.326,0,1.832 c0.253,0.254,0.584,0.379,0.917,0.379s0.663-0.127,0.917-0.379l6.901-6.901l6.9,6.901c0.254,0.254,0.585,0.379,0.917,0.379 c0.33,0,0.662-0.127,0.915-0.379c0.507-0.506,0.507-1.326,0-1.832L31.707,24.435z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRevert);
export default __webpack_public_path__ + "static/media/revert.78e34231.svg";
export { ForwardRef as ReactComponent };